export default __webpack_public_path__ + "static/general_assembly_regulation-e3f794255d6e086c61f477c05e3b0566.pdf";